const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
}

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
}

class CustomerAddresses extends HTMLElement {
  constructor() {
    super()

    this.elements = this._getElements()
    if (Object.keys(this.elements).length === 0) return
    this._setupCountries()
    this._setupEventListeners()
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses)
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(
            selectors.toggleAddressButton
          ),
          cancelButtons: container.querySelectorAll(
            selectors.cancelAddressButton
          ),
          deleteButtons: container.querySelectorAll(
            selectors.deleteAddressButton
          ),
          countrySelects: container.querySelectorAll(
            selectors.addressCountrySelect
          ),
        }
      : {}
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew',
        }
      )
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(
          `AddressCountry_${formId}`,
          `AddressProvince_${formId}`,
          {
            hideElement: `AddressProvinceContainer_${formId}`,
          }
        )
      })
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick)
    })

    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick)
    })

    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick)
    })
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    )
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget)
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      })
    }
  }
}

customElements.define('customer-addresses', CustomerAddresses)

/**
 * Select Element Floating Style
 */
document.querySelectorAll('.floating-label select').forEach((select) => {
  select.classList.toggle('float', select.value)
  select.addEventListener('change', () => {
    select.classList.toggle('float', select.value)
  })
})

/**
 * Error Styling
 */
function styleErrors(form) {
  function removeErrorBox(element) {
    if (element.value) {
      element.parentElement.classList.remove('invalid')
    }

    let allFilled = true
    form
      .querySelectorAll('.service-form--field.required input')
      .forEach((element) => {
        if (element.value === '') {
          allFilled = false
        }
      })

    if (allFilled) {
      form.querySelector('.service-form--errormsg')?.classList.add('hidden')
    }
  }

  form
    .querySelectorAll('.service-form--field input, .service-form--field select')
    .forEach((element) => {
      element.addEventListener('focusout', () => {
        removeErrorBox(element)
      })
      element.addEventListener('change', () => {
        removeErrorBox(element)
      })
      element.addEventListener('keypress', () => {
        removeErrorBox(element)
      })
    })
}

/**
 * Form Validation
 */

function validateElement(element) {
  function isHiddenField(element) {
    let currElement = element
    while (currElement) {
      const computedStyle = window.getComputedStyle(currElement)
      if (computedStyle.display === 'none') {
        return true
      }
      currElement = currElement.parentElement
    }

    return false
  }

  const {
    tagName,
    type,
    value,
    checked,
    parentElement: { className },
  } = element

  const required = className.includes('required') && !isHiddenField(element)

  if (element.id === 'phone') {
    if (value.length > 9) {
      element.parentElement.classList.remove('invalid')
      return true
    } else {
      element.parentElement.classList.add('invalid')
      return false
    }
  }

  if (
    (((tagName === 'INPUT' && type === 'text') ||
      (tagName === 'INPUT' && type === 'number') ||
      (tagName === 'INPUT' && type === 'email') ||
      (tagName === 'INPUT' && type === 'password') ||
      tagName === 'SELECT') &&
      required &&
      !value) ||
    (tagName === 'INPUT' && type === 'checkbox' && required && !checked)
  ) {
    element.parentElement.classList.add('invalid')
    return false
  } else {
    element.parentElement.classList.remove('invalid')
    return true
  }
}

async function validateForm(event, form, subscribe = false, register = true) {
  event?.preventDefault()

  let validated = true

  const elements = form.querySelectorAll(
    '.service-form--field input, .service-form--field select'
  )
  for (let index = 0; index < elements.length; index++) {
    const element = elements[index]

    validated = this.validateElement(element) && validated
  }

  if (validated) {
    const optinCheck = document.getElementById('accepts-marketing')

    if (subscribe && optinCheck?.checked) {
      if (register) {
        const countrySelect = document.getElementById('RegisterForm-Country')
        const firstNameInput = document.getElementById('RegisterForm-FirstName')
        const lastNameInput = document.getElementById('RegisterForm-LastName')
        const emailInput = document.getElementById('RegisterForm-email')

        const profileResponse = await fetch(
          'https://bdsgallery-function.azurewebsites.net/api/klaviyo_profile',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email: emailInput.value,
                  first_name: firstNameInput.value,
                  last_name: lastNameInput.value,
                  location: {
                    country: countrySelect.value,
                  },
                  properties: {
                    source: 'service Form',
                  },
                },
              },
            }),
            redirect: 'follow',
          }
        )

        const profileData = await profileResponse.json()

        await fetch('https://bdsgallery-function.azurewebsites.net/api/klaviyo_subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'profile-subscription-bulk-create-job',
              attributes: {
                custom_source: 'Marketing Event',
                profiles: {
                  data: [
                    {
                      type: 'profile',
                      attributes: {
                        id: profileData['data']['id'],
                        email: profileData['data']['attributes']['email'],
                        subscriptions: {
                          email: {
                            marketing: {
                              consent: 'SUBSCRIBED',
                            },
                          },
                        },
                      },
                    },
                  ],
                  country: countrySelect.value,
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id:
                      countrySelect.value === 'United States'
                        ? 'S7eRyL'
                        : 'TBwmnw',
                  },
                },
              },
            },
          }),
          redirect: 'follow',
        })
      } else {
        const countrySelect = form.querySelector(
          'select[name="address[country]"]'
        )
        const firstNameInput = form.querySelector(
          'input[name="address[first_name]"]'
        )
        const lastNameInput = form.querySelector(
          'input[name="address[last_name]"]'
        )
        const emailInput = form.querySelector('input[name="address[email]"]')

        /**
         * Go to Other country and unsubscribe. If US is selected, unsubscribe from UK.  If UK is selected, unsubscribe from US.
         */
        const prevProfileResponse = await fetch(
          'https://bdsgallery-function.azurewebsites.net/api/klaviyo_profile',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email: emailInput.value,
                  first_name: firstNameInput.value,
                  last_name: lastNameInput.value,
                  location: {
                    country:
                      countrySelect.value === 'United States'
                        ? 'United Kingdom'
                        : 'United States',
                  },
                  properties: {
                    source: 'service Form',
                  },
                },
              },
            }),
            redirect: 'follow',
          }
        )

        const prevProfileData = await prevProfileResponse.json()

        await fetch(
          'https://bdsgallery-function.azurewebsites.net/api/klaviyo_unsubscribe',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                type: 'profile-subscription-bulk-delete-job',
                attributes: {
                  profiles: {
                    data: [
                      {
                        type: 'profile',
                        attributes: {
                          email: prevProfileData['data']['attributes']['email'],
                        },
                      },
                    ],
                    country:
                      countrySelect.value === 'United States'
                        ? 'United Kingdom'
                        : 'United States',
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id:
                        countrySelect.value !== 'United States'
                          ? 'S7eRyL'
                          : 'TBwmnw',
                    },
                  },
                },
              },
            }),
            redirect: 'follow',
          }
        )

        /**
         * Next, subscribe to the selected country
         */
        const profileResponse = await fetch(
          'https://bdsgallery-function.azurewebsites.net/api/klaviyo_profile',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email: emailInput.value,
                  first_name: firstNameInput.value,
                  last_name: lastNameInput.value,
                  location: {
                    country: countrySelect.value,
                  },
                  properties: {
                    source: 'service Form',
                  },
                },
              },
            }),
            redirect: 'follow',
          }
        )

        const profileData = await profileResponse.json()

        await fetch('https://bdsgallery-function.azurewebsites.net/api/klaviyo_subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'profile-subscription-bulk-create-job',
              attributes: {
                custom_source: 'Marketing Event',
                profiles: {
                  data: [
                    {
                      type: 'profile',
                      attributes: {
                        id: profileData['data']['id'],
                        email: profileData['data']['attributes']['email'],
                        subscriptions: {
                          email: {
                            marketing: {
                              consent: 'SUBSCRIBED',
                            },
                          },
                        },
                      },
                    },
                  ],
                  country: countrySelect.value,
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id:
                      countrySelect.value === 'United States'
                        ? 'S7eRyL'
                        : 'TBwmnw',
                  },
                },
              },
            },
          }),
          redirect: 'follow',
        })
      }
    }

    form.submit()
  } else {
    const firstErrorEle = document.querySelector(
      '.service-form--field.invalid input, .service-form--field.invalid select'
    )
    if (firstErrorEle) {
      firstErrorEle.scrollIntoView({ behavior: 'smooth', block: 'center' })

      setTimeout(() => {
        firstErrorEle.focus()
      }, 1000)
    }

    const errorMessageBox = form.querySelector('.service-form--errormsg')
    errorMessageBox.classList.remove('hidden')
  }
}

/**
 * reCaptcha v3
 */
function onRegisterSubmit() {
  const form = document.getElementById('create_customer')
  validateForm(null, form, true)
}

/**
 * Customer Registration Form
 */
class CustomerRegisterForm extends HTMLElement {
  constructor() {
    super()

    this.form = document.getElementById('create_customer')
    this.submitBtn = this.form.querySelector('input[type="submit"]')
    this.passwordEle = document.getElementById('RegisterForm-password')
    this.warningBox = document.getElementById('nist-validator')
    this.flags = document.querySelectorAll('.country-switcher--item')
    this.countryField = document.getElementById('RegisterForm-Country')

    this.passwordEle.addEventListener('input', this.nistValidation.bind(this))

    this.flags.forEach((flagEle) =>
      flagEle.addEventListener('click', () => this.changeCountry(flagEle))
    )

    styleErrors(this.form)
  }

  async nistValidation() {
    async function getSha256(text) {
      const encoder = new TextEncoder()
      const data = encoder.encode(text)

      const hashBuffer = await crypto.subtle.digest('SHA-256', data)

      const hashArray = Array.from(new Uint8Array(hashBuffer))
      const hashHex = hashArray
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('')

      return hashHex
    }

    async function checkPassword(password) {
      const sha256Password = await getSha256(password)

      const prefix = sha256Password.substr(0, 10)

      const response = await fetch(`https://api.enzoic.com/v1/passwords`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Basic NWRiNjgyN2NmZTcwNDk4N2E3NGMzYTMxN2VlMzRlZDA6NEMkSzMmK200LWMrUSZ4eE5BVmR5dkptTSZLXiU3OEU=',
        },
        body: JSON.stringify({
          partialSHA256: prefix,
        }),
      })

      if (response.status !== 200) {
        return 0
      } else {
        const data = await response.json()
        return data?.candidates?.[0]?.exposureCount ?? 0
      }
    }

    this.warningBox.classList.remove('hidden')

    const password = this.passwordEle.value

    const isLongEnough = password.length >= 8
    const hasUppercase = /[A-Z]/.test(password)
    const hasLowercase = /[a-z]/.test(password)
    // const commonCount = await checkPassword(password)
    const commonCount = 0

    this.warningBox.dataset.length = isLongEnough ? 'true' : 'false'
    this.warningBox.dataset.case =
      hasUppercase && hasLowercase ? 'true' : 'false'
    this.warningBox.dataset.common =
      commonCount < 100 && password.length > 0 ? 'true' : 'false'

    if (isLongEnough && hasUppercase && hasLowercase && commonCount < 100) {
      this.submitBtn.removeAttribute('disabled')
    } else {
      this.submitBtn.setAttribute('disabled', true)
    }
  }

  changeCountry(flagEle) {
    const country = flagEle.dataset.country

    this.flags.forEach((flagEle) => flagEle.classList.remove('selected'))

    flagEle.classList.add('selected')

    this.countryField.value = country
  }
}

customElements.define('customer-register', CustomerRegisterForm)

/**
 * Customer Login Form
 */
class CustomerLoginForm extends HTMLElement {
  constructor() {
    super()

    // Login Page
    this.form = document.getElementById('customer_login')
    if (this.form) {
      this.submitBtn = this.form.querySelector('input[type="submit"]')

      if (localStorage.getItem('last_login_email')) {
        document.getElementById('CustomerEmail').value =
          localStorage.getItem('last_login_email')
      }

      this.submitBtn.addEventListener('click', (event) => {
        validateForm(event, this.form)
        localStorage.setItem(
          'last_login_email',
          document.getElementById('CustomerEmail').value
        )
      })

      styleErrors(this.form)
    }

    // Reset Page
    this.resetForm = document.querySelector('#recover form')
    this.resetSubmitBtn = this.resetForm.querySelector('input[type="submit"]')

    if (localStorage.getItem('last_login_email')) {
      document.getElementById('RecoverEmail').value =
        localStorage.getItem('last_login_email')
    }

    this.resetSubmitBtn.addEventListener('click', (event) => {
      validateForm(event, this.resetForm)
      localStorage.setItem(
        'last_login_email',
        document.getElementById('RecoverEmail').value
      )
    })

    styleErrors(this.resetForm)
  }
}

customElements.define('customer-login', CustomerLoginForm)

/**
 * Customer Profile Form
 */
class CustomerProfileForm extends HTMLElement {
  constructor() {
    super()

    this.form = document.querySelector('form')
    this.submitBtn = this.form.querySelector('input[type="submit"]')

    this.countrySelect = document.querySelector('.country-select')
    this.phoneInput = this.form.querySelector('input[name="address[phone]"]')
    this.zipInput = this.form.querySelector('input[name="address[zip]"]')

    this.stateContainer = this.form.querySelector('.state-dropdown select')
    this.usStatesSelect = this.form.querySelector('.us-states select')
    this.usStatesHTML = this.usStatesSelect.innerHTML
    this.ukStatesSelect = this.form.querySelector('.uk-states select')
    this.ukStatesHTML = this.ukStatesSelect.innerHTML

    this.submitBtn.addEventListener('click', (event) => {
      validateForm(event, this.form, true, false)
    })

    styleErrors(this.form)

    /**
     * Input Formatting
     */
    this.form
      .querySelectorAll('.service-form--field input[type="text"]')
      .forEach((input) => {
        input.addEventListener('input', this.formatInput.bind(this), false)
      })

    this.phoneInput.dispatchEvent(new Event('input'))

    /**
     * Country Switcher
     */
    this.countrySelect.addEventListener('change', () => {
      const isUSAddress =
        this.countrySelect.value === 'United States' ||
        this.countrySelect.value === 'Puerto Rico'

      this.form.classList.toggle('us', isUSAddress)

      this.stateContainer.innerHTML =
        this.countrySelect.value === 'United States'
          ? this.usStatesHTML
          : this.countrySelect.value === 'United Kingdom'
          ? this.ukStatesHTML
          : ''
      this.stateContainer.classList.add('float')
    })

    this.countrySelect.dispatchEvent(new Event('change'))
  }

  formatInput(event) {
    switch (event.target) {
      case this.phoneInput:
        this.phoneInput.value = this.phoneInput.value.substring(0, 15)

        break

      case this.zipInput:
        this.zipInput.value = this.zipInput.value
          .replace(/[^a-zA-Z0-9 ]/g, '')
          .substring(0, 10)

        break

      default:
        break
    }
  }
}

customElements.define('customer-profile', CustomerProfileForm)
